import React from 'react';
import { api_route, user_logout } from '../../helpers/Global';
import { withRouter } from 'react-router-dom';
import ColisAction from './ColisAction';

class ColisJournal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            liste_historique: [],
            liste_messages: [],
            liste_calls: [],
        }
    }
    
    componentDidMount() {
        this.props.setCurrentPage('coli_journal');
        window.scrollTo(0, 0);
        
        fetch(api_route('infos-colis') + '&colis_barecode=' + this.props.selected_coli.barecode, { method: 'GET' })
        .then(resp => resp.json())
        .then(resp => {
            if (resp.response === 'error-connected') {
                user_logout();
                this.props.history.push(`/user-logout`);
            } else if (resp['liste_historique']) {
                this.setState({ liste_historique: resp['liste_historique'] });
                this.setState({ liste_messages: resp['liste_messages'] });
                this.setState({ liste_calls: resp['liste_calls'] });

            }
        })
       .catch(err => {
            this.props.loaderDisplay(false);
            this.props.openErrorSystem(true);
        })

    }

    render() {
        const coli = this.props.selected_coli || {};
        //const calls = coli['liste-calls'] || [];
        //const historiques = coli['liste-historique'] || [];
        var calls = this.state.liste_calls;
        var historiques = this.state.liste_historique;
        var messages = this.state.liste_messages;
        
        if (this.props.coli_action) {
            return (
                <ColisAction
                    loaderDisplay={this.props.loaderDisplay}
                    coli={this.props.selected_coli}
                    coli_action={this.props.coli_action}
                    initColiAction={this.props.initColiAction}
                    setCurrentPage={this.props.setCurrentPage}
                    current_page={this.props.current_page}
                    openErrorSystem={this.props.openErrorSystem}
                />
            );
        }
        
        return (
            <React.Fragment>
                <div className="row mb-4 bg-template-opacity">
                    <div className="container py-4">
                        <div className="row">
                            <div className="col">
                                <h5 className="font-weight-normal template-primary">{coli.barecode}</h5>

                                
                                {coli.lastcall && (
                                    <React.Fragment>  
                                        <p className="text-secondary mb-0">
                                         <span className='text-success' style={{ 'fontSize': '14px' }}><small>{coli.lastcall}</small></span><br />
                                         </p>
                                    </React.Fragment>
                                )}
                           

                                <p className="text-secondary mb-0">
                                    <strong className='text-primary' style={{ 'fontSize': '14px' }}>
                                        {React.createElement('b', { dangerouslySetInnerHTML: { __html: coli.min_statut } })}
                                    </strong><br /><br />
                                </p>

                                <p className="text-secondary mb-0">
                                    <span className="font-weight-normal"><i className="material-icons ml-0 md-18">qr_code</i>
                                        {coli.tracking_number}
                                    </span><br />
                                </p>

                                <p className="text-secondary mb-0">
                                    <span className="font-weight-normal"><i className="material-icons ml-0 md-18">person</i>
                                        {coli.recipient_name}
                                    </span><br />
                                </p>

                                <p className="text-secondary mb-0">
                                    <span className="font-weight-normal"><i className="material-icons ml-0 md-18">phone</i>
                                        {coli.recipient_phone}
                                    </span><br />
                                </p>

                                <p className="text-secondary mb-0">
                                    <span className="font-weight-normal"><i className="material-icons ml-0 md-18">attach_money</i>
                                        {coli.price}
                                    </span><br />
                                </p>

                                <p className="text-secondary mb-0">
                                    <span className="font-weight-normal"><i className="material-icons ml-0 md-18">location_on</i>
                                        {coli.recipient_address}
                                    </span>
                                </p>


                                {this.props.coli_btn_action && (
                                    <React.Fragment>           
                                        <button style={{"marginTop":"10px"}} className="btn-lcolis buynow btn btn-success text-uppercase" onClick={() => this.props.openConfirmModal(true, coli)}>Livrer <i className="material-icons md-18 ml-1">check</i></button>
                                        <button style={{"marginRight":"10px","marginTop":"10px"}} type="button" className="btn-lcolis buynow btn btn-danger text-uppercase" onClick={() => this.props.coliActions(coli, 'echec')}>Échec <i className="material-icons md-18 ml-1">error_outline</i></button>
                                    </React.Fragment>
                                )}

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="container">
                        <div className="row">
                            
                            {messages.length > 0 && (
                                <React.Fragment>  
                                    <div className="col-12 col-md-12">
                                        <div className="card mb-4 border-0 shadow-sm">
                                            <div className="card-header">
                                                <h6 className="card-title">Messages / Réclamations</h6>
                                            </div>
                                            <div className="card-body h320 p-0">
                                                <ul className="list-group list-group-flush timeline-small">
                                                    {messages.map((message, indice) =>
                                                        <li className="list-group-item" key={indice}>
                                                            <div className="avatar avatar-20 border-warning"></div>
                                                            <p>
                                                                {React.createElement('span', { dangerouslySetInnerHTML: { __html: message.created_by } })}
                                                                <br />
                                                                <small className="text-secondary">{message.created_at}</small> <br />
                                                                <small className="text-secondary">{React.createElement('b', { dangerouslySetInnerHTML: { __html: message.message } })}</small><br />
                                                                {message.answer && (
                                                                    <React.Fragment>  
                                                                        <small className="text-secondary"><b class='text-danger'>Réponse : </b>{React.createElement('b', { dangerouslySetInnerHTML: { __html: message.answer } })}</small>
                                                                    </React.Fragment>
                                                                )}

                                                                {!message.answer && (
                                                                    <React.Fragment>  
                                                                        <button style={{"marginTop":"10px"}} className="btn-message buynow btn btn-success text-uppercase" onClick={() => this.RedirectToReplyMessage(true, message)}>Répondre <i className="material-icons md-18 ml-1">reply</i></button>
                                                                    </React.Fragment>
                                                                )}
                                                            </p>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                              </React.Fragment>
                            )}
                            
                            {historiques.length > 0 && (
                                <React.Fragment>  
                                    <div className="col-12 col-md-12">
                                        <div className="card mb-4 border-0 shadow-sm">
                                            <div className="card-header">
                                                <h6 className="card-title">Historique de suivi</h6>
                                            </div>
                                            <div className="card-body h320 p-0">
                                                <ul className="list-group list-group-flush timeline-small">
                                                    {historiques.map((hist, indice) =>
                                                        <li className="list-group-item" key={indice}>
                                                            <div className="avatar avatar-20 border-danger"></div>
                                                            <p>
                                                                {React.createElement('span', { dangerouslySetInnerHTML: { __html: hist.label_statut } })}
                                                                <br />
                                                                <small className="text-secondary">{hist.created_at}</small> <br />
                                                                <small className="text-secondary">Par {hist.created_by}</small>
                                                            </p>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}

                            {calls.length > 0 && (
                                <React.Fragment>  
                                    <div className="col-12 col-md-12">
                                        <div className="card mb-4 border-0 shadow-sm">
                                            <div className="card-header">
                                                <h6 className="card-title">Liste des appels</h6>
                                            </div>
                                            <div className="card-body h320 p-0">
                                                <ul className="list-group list-group-flush timeline-small">
                                                    {calls.map((call, indice) =>
                                                        <li className="list-group-item" key={indice}>
                                                            <div className="avatar avatar-20 border-success"></div>
                                                            <p>
                                                                {React.createElement('span', { dangerouslySetInnerHTML: { __html: call.reponse } })}
                                                                <br />
                                                                <small className="text-secondary">{call.datecall}</small> <br />
                                                                <small className="text-secondary">Par {call.created_by}</small>
                                                            </p>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                              </React.Fragment>
                            )}


                            

                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    RedirectToReplyMessage = (v, message = null) => {
       this.props.history.push("/reply/message-livreur?message_id="+message.id); 
    }

}

export default withRouter(ColisJournal);
